import {
  GET_EXCO_KELURAHAN,
  GET_EXCO_KELURAHAN_SUCCESS,
  GET_EXCO_KELURAHAN_FAIL,
} from "./actionTypes";

const initialState = {
  dataKelurahan: {
    loading: false,
    error: false,
    data: null,
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_EXCO_KELURAHAN:
      return {
        ...state,
        dataKelurahan: {
          ...state.dataKelurahan,
          loading: true,
          error: false,
          isLoggedIn: false,
        },
      };
    case GET_EXCO_KELURAHAN_SUCCESS:
      return {
        ...state,
        dataKelurahan: {
          ...state.dataKelurahan,
          loading: false,
          error: false,
          isLoggedIn: true,
          data: action.payload,
        },
      };
    case GET_EXCO_KELURAHAN_FAIL:
      return {
        ...state,
        dataKelurahan: {
          ...state.dataKelurahan,
          loading: false,
          error: action.payload,
          isLoggedIn: false,
        },
      };
    default:
      return state;
  }
};

export default reducer;
